import { actionTypes, NAMESPACE } from "./constants";

import { createModule } from "redux-mvc";
import { initSaga } from "./sagas";

const initialState = {
  flags: {},
  loading: false,
  error: null
};

const module = createModule({
  namespace: NAMESPACE,
  iniState: initialState,
  reducer: (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.FETCH_FLAGS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };

      case actionTypes.FETCH_FLAGS_SUCCESS:
        return {
          ...state,
          loading: false,
          flags: action.payload
        };

      case actionTypes.FETCH_FLAGS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };

      default:
        return state;
    }
  },
  sagas: [initSaga]
});
export * from "./actions";
export * from "./selectors";
export default module;
